/* eslint-disable react/display-name */

import { Box, CssBaseline, Icon, IconButton } from '@material-ui/core';
import {
  createMuiTheme,
  makeStyles,
  MuiThemeProvider,
} from '@material-ui/core/styles';
import axios from 'axios';
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { EntitySlideFullscreen } from '../info/EntitySlideFullscreen';

const slideTypes = require('../../../../../shared/schemas/entities/entitySlide.json');

const useStyles = makeStyles(() => ({
  slideHolder: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
  },
  navigationHolder: {
    zIndex: 10,
    position: 'absolute',
    top: 0,
    left: '50%',
    marginLeft: -75,
  },
  navigationBox: {
    color: '#ddd',
    width: 150,
    height: 40,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    backgroundColor: 'rgba(0,0,0,0.2)',
    opacity: 0,
    '&:hover': {
      backgroundColor: '#000',
      opacity: '1!important',
    },
  },
  navLeftArrow: {
    paddingLeft: 4,
  },
  showNav: {
    opacity: 0.5,
  },
}));

const EntitySlideShow = (props) => {
  const classes = useStyles();
  const showNavTimer = useRef();
  const [showNav, setShowNav] = useState(true);
  const [, setEntity] = useState(null);
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  const gotoSlide = (dir) => {
    setCurrentSlide((lastSlide) => {
      return (slides.length + lastSlide + dir) % slides.length;
    });
  };
  const keyPress = (e) => {
    switch (e.key) {
      case 'ArrowRight':
        gotoSlide(1);
        break;
      case 'ArrowDown':
        gotoSlide(1);
        break;
      case 'ArrowUp':
        gotoSlide(-1);
        break;
      case 'ArrowLeft':
        gotoSlide(-1);
        break;
    }
  };
  const refresh = () => {
    axios
      .get(`/api/visitor/entities/${props.entityId}`, {})
      .then((response) => {
        setEntity(response.data);
        setSlides(
          response.data.entitySlides
            .filter((es) => !slideTypes.properties[es.data.type].noslide)
            .map((es) => ({
              ...es.data,
              id: es.id,
            }))
        );
      });
  };

  useEffect(() => {
    document.title = 'Slideshow';
    refresh();
  }, []);

  useEffect(() => {
    // Show navigation each time the slide changes
    setShowNav(true);
    clearTimeout(showNavTimer.current);
    showNavTimer.current = setTimeout(() => setShowNav(false), 2000);
  }, [currentSlide]);

  useEffect(() => {
    window.addEventListener('keydown', keyPress);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', keyPress);
    };
  }, [slides.length]);

  return (
    <MuiThemeProvider theme={createMuiTheme({ palette: { type: 'dark' } })}>
      <Box>
        <CssBaseline />

        {slides.length > 0 && (
          <Box className={classes.slideHolder}>
            <EntitySlideFullscreen
              fullscreen={true}
              data={{
                type: slides[currentSlide].type,
                data: slides[currentSlide].data,
              }}
            />
          </Box>
        )}
        <Box className={classes.navigationHolder}>
          <Box
            className={clsx(classes.navigationBox, showNav && classes.showNav)}
            display="flex"
            alignItems="center"
          >
            <Box>
              <IconButton color="inherit" onClick={() => gotoSlide(-1)}>
                <Icon className={classes.navLeftArrow}>arrow_back_ios</Icon>
              </IconButton>
            </Box>
            <Box flexGrow={1} align="center">
              {currentSlide + 1}/{slides.length}
            </Box>
            <Box>
              <IconButton color="inherit" onClick={() => gotoSlide(1)}>
                <Icon>arrow_forward_ios</Icon>
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </MuiThemeProvider>
  );
};

export default EntitySlideShow;
